import { render } from "./Login.vue?vue&type=template&id=3825bbae"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=3825bbae&lang=css"

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__